(ns ycweb.app.website.cart.bridge
  (:require
   [ycweb.app.website.cart.model :as cart.model]
   [ycweb.util.core :as u]))

(defonce ^:private button-states (atom {}))

(defn toggle-button-loading
  "Toggle loading state for a button element.
   is-loading: boolean - whether to show loading or restore original state
   button: DOM element - the button to modify
   button-html: string - original button HTML content (for restoring)
   set-disabled: boolean - whether to disable the button during loading"
  [is-loading button-id set-disabled]
  #?(:cljs
     (let [{:keys [button html]} (get @button-states button-id)
           body (.-body js/document)]
       (if is-loading
      ;; Set loading state
         (do
           (set! (.. body -style -cursor) "wait")
           (when set-disabled
             (set! (.-disabled button) true))
           (when button
             (set! (.. button -style -cursor) "wait")
             (when html
               (let [set-html "Loading&hellip;"
                     icon-class (.getAttribute button "data-load-with-icon")]
                 (set! (.-innerHTML button)
                   (if icon-class
                     (str "<i class=\"" icon-class "\"></i>" set-html)
                     set-html))))))
      ;; Restore normal state
         (do
           (set! (.. body -style -cursor) "auto")
           (when set-disabled
             (set! (.-disabled button) false))
           (when button
             (set! (.. button -style -cursor) "pointer")
             (when html
               (set! (.-innerHTML button) html))))))))

;; Bridge code for hijacking existing add to cart buttons
;; Helper function to check if an element is visible
(defn is-element-visible? [element]
  #?(:cljs
     (when element
       (let [style (js/window.getComputedStyle element)
             display-val (.-display style)
             visibility-val (.-visibility style)
             opacity-val (.-opacity style)]
         (println "DEBUG: Element visibility check -"
           "display:" display-val
           "visibility:" visibility-val
           "opacity:" opacity-val)
         (and (not= "none" display-val)
           (not= "hidden" visibility-val)
           (not= "0" opacity-val))))))

;; Function to extract product data from the add to cart form or nearby elements
(defn extract-product-data [button-element]
  #?(:cljs
     (let [;; Get the form using closest instead of traversing parents
           form (.closest button-element "form")

    ;; Try to get variationuuid from data attribute on button first
           variation-uuid-from-button
           (or (.getAttribute button-element "data-variationuuid")
             (.getAttribute button-element "data-variation-uuid"))

;; Find all quantity selectors directly from document
           all-qty-selects
           (js/document.querySelectorAll ".js-addToCartQty")

;; Find the visible parent container(s) for quantity selectors
           visible-qty-containers
           (array-seq (js/document.querySelectorAll ".qtySelector[style*='display: block']"))

;; Find the qty select within the visible container
           qty-select
           (when (seq visible-qty-containers)
             (let [container (first visible-qty-containers)]
               (.querySelector container ".js-addToCartQty")))

;; If no qty select found in visible container, fall back to visibility check
           qty-select
           (or qty-select
             (let [visible-qty-selects (filter is-element-visible? (array-seq all-qty-selects))]
               (first visible-qty-selects)))

    ;; Get the data-variationuuid attribute from the qty select itself, if it exists
           qty-select-variation-uuid
           (when qty-select
             (or (.getAttribute qty-select "data-variationuuid")
               (.getAttribute qty-select "data-variation-uuid")))

;; Find the variationid either from button or from a field
           variation-id-from-button
           (or (.getAttribute button-element "data-variationid")
             (.getAttribute button-element "data-variation-id"))

           variation-id-from-select
           (when qty-select
             (or (.getAttribute qty-select "data-variationid")
               (.getAttribute qty-select "data-variation-id")))

           variation-id (or variation-id-from-button variation-id-from-select)

;; Combine all sources to get the variation_uuid
           variation-uuid (or qty-select-variation-uuid variation-uuid-from-button)

    ;; Get qty from the qty select and parse as integer
           qty-str (if qty-select (.-value qty-select) "1")
           qty (js/parseInt qty-str 10)

    ;; Extract addsource from hidden form input
           ;; Try multiple methods to find addsource
           addsource-input
           (or
             (when form (.querySelector form "input[name='addsource']"))
             (when form (.querySelector form "input[name=\"addsource\"]"))
             ;; Fallback: search from button's form
             (let [button-form (.closest button-element "form")]
               (when button-form (.querySelector button-form "input[name='addsource']")))
             ;; Final fallback: search entire document
             (js/document.querySelector "input[name='addsource']"))
           addsource (when addsource-input (.-value addsource-input))]

       (println "FINAL extraction results - variation_uuid:" variation-uuid
         "variation_id:" variation-id
         "qty:" qty
         "addsource:" addsource)

       {:variation_uuid variation-uuid
        :qty qty
        :addsource addsource})))

;; Super hacky, low impact implementation just until we port the product pages
;; properly.
(defn hijack-add-to-cart-buttons [app-atom]

  (println "Setting up add-to-cart button handlers...")
  #?(:cljs
     (let [add-to-cart-buttons (js/document.querySelectorAll "[name='addToCartButton']")]
       (println "Found" (.-length add-to-cart-buttons) "add to cart buttons on the page")
       (doseq [i (range (.-length add-to-cart-buttons))]
         (let [original-button (aget add-to-cart-buttons i)]

      ;; Create a completely new button instead of just cloning to ensure no event handlers are preserved
           (let [new-button (js/document.createElement "button")
                 button-id (str "add-to-cart-" i "-" (u/uuid))]
      ;; Copy all attributes from the original button
             (doseq [j (range (.-length (.-attributes original-button)))]
               (let [attr (aget (.-attributes original-button) j)]
                 (.setAttribute new-button (.-name attr) (.-value attr))))

      ;; Set the innerHTML to match the original button
             (set! (.-innerHTML new-button) (.-innerHTML original-button))

      ;; Store the original HTML for restoring after loading state
             (let [original-html (.-innerHTML new-button)]

      ;; Remove all original event handlers by explicitly setting onclick to null
               (set! (.-onclick original-button) nil)

      ;; Add our custom handler
               (.addEventListener new-button "click"
                 (fn [e]
                   (.preventDefault e)
                   (.stopPropagation e) ;; Stop any other handlers in the bubble chain

                   (swap! button-states assoc button-id
                     {:button new-button
                      :html original-html})

                ;; Show loading state
                   (toggle-button-loading true button-id true)

        ;; Extract product data from the original button
                   (when-let [product-data (extract-product-data original-button)]

        ;; Add to cart via our function with button info for restoration
                     (cart.model/add-to-cart app-atom product-data
                       (fn [response]
                         (toggle-button-loading false button-id true)
                         (cart.model/open-add-to-cart-modal app-atom response
                           :variation-uuid (:variation_uuid product-data)))))))

;; Replace the original button
               (.replaceWith original-button new-button))))))))

;; Setup function to be called from main
(defn setup-button-hijacking [app-atom]
  ;; Use a different name to avoid shadowing the global app-atom
  #?(:cljs
     (do
       (println "Setting up button hijacking with timeout...")
       (js/setTimeout #(hijack-add-to-cart-buttons app-atom) 500))))